import { fromZonedTime } from 'date-fns-tz';
import { TimeRange } from 'store/resource-time-ranges/types';

export function isDateInBetweenInclusive(date: Date, start: Date, end: Date) {
  return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
}
export function startTimeRangeToLocalDateTime(timeRange: TimeRange, timezone: string): Date {
  return fromZonedTime(`${timeRange.date} ${timeRange.time}:00.000`, timezone);
}

export function endTimeRangeToLocalDateTime(timeRange: TimeRange, timezone: string): Date {
  const start = startTimeRangeToLocalDateTime(timeRange, timezone);
  return new Date(start.getTime() + timeRange.time_interval * 60 * 1000);
}

export function getTimeRangesFromNow(timeRanges: TimeRange[], timezone: string): TimeRange[] {
  const now = new Date(Date.now());
  return timeRanges.filter(timeRange => endTimeRangeToLocalDateTime(timeRange, timezone) > now);
}

export function isActiveForCurrentTime(timeRange: TimeRange, timezone: string): boolean {
  const now = new Date(Date.now());
  return (
    startTimeRangeToLocalDateTime(timeRange, timezone) <= now && endTimeRangeToLocalDateTime(timeRange, timezone) > now
  );
}

export function startsAfterCurrentTime(timeRange: TimeRange, timezone: string): boolean {
  const now = new Date(Date.now());
  return startTimeRangeToLocalDateTime(timeRange, timezone) > now;
}
